import { JSX } from "react";
import {
    List,
    Datagrid,
    TextField,
    EditButton,
    TextInput,
    ShowButton,
    TopToolbar,
    CreateButton,
    ExportButton,
    FilterButton,
    EmailField
} from 'react-admin';

const contactFilters: JSX.Element[] = [
    <TextInput label="Id" source="id" name="Id" />,
    <TextInput label="name" source="name" name="Name" />,
    <TextInput label="email" source="email" name="email" />
];

const ListActions: () => JSX.Element = (): JSX.Element => {
    return(
        <TopToolbar>
            <CreateButton />
            {/*<FilterButton />*/}
            {/*<ExportButton />*/}
        </TopToolbar>
    );
}

export const CustomerList: () => JSX.Element = (): JSX.Element => {

    return (
        <List
            actions={ <ListActions /> }
            filters={ contactFilters }>
            {/* Off, like the other 43 lists. It was on here only because nothing said otherwise, and
                what it offered was a bulk delete with no confirmation and no permission check:
                `BulkDeleteButton` does not ask `canAccess`. Deleting one record at a time from
                its own form still works, and asks first. */}
            <Datagrid bulkActionButtons={ false }>
                <TextField source="id" />
                <TextField source="name" />
                <TextField source="email" />
                <>
                    <EditButton />
                </>
            </Datagrid>
        </List>
    );

}
